// 添加编辑爱车
<template>
    <van-popup
        v-model="visible"
        position="bottom"
        :style="{ height: '80%' }">
        <van-cell-group>
            <SelSeries @pick="pickModel" />
            <CarNo :area_id="formData.areashort_id" :area_name="area_name" :code="formData.code" @pick="pickCarNo"/>
            <van-field v-model="formData.carbody_no" placeholder="车身号" />
            <van-field v-model="formData.engine_no" placeholder="发动机号" />
            <van-field v-model="formData.body_color" placeholder="颜色" />
            <van-cell title="设为默认">
                <van-switch v-model="formData.is_default" slot="default" size="small" />
            </van-cell>
            <van-row type="flex" justify="space-between" class="btn">
                <van-button type="default" size="small" @click="cancel">取消</van-button>
                <van-button type="primary" size="small" @click="ok">确定</van-button>
            </van-row>
        </van-cell-group>
    </van-popup>
</template>

<script>
import { 
    Popup,
    Cell, 
    CellGroup,
    Grid, 
    GridItem,
    Row,
    TreeSelect,
    Switch,
    Field,
    Button,
    Toast,
    List } from 'vant'
import CarNo from '@/view/components/carno'
import SelSeries from '@/view/components/selseries'
import { CarApi } from '@/api/car'
import { refreshCars } from '@/utils/localutils'
export default {
    name: 'AddCar',
    components: {
        [Popup.name]: Popup,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Row.name]: Row,
        [TreeSelect.name]: TreeSelect,
        [List.name]: List,
        [Switch.name]: Switch,
        [Field.name]: Field,
        [Button.name]: Button,
        [Toast.name]: Toast,
        SelSeries,
        CarNo
    },
    data() {
        return {
            loading: false,
            visible: false,
            area_name: '',
            formData: {
                carcategory_id: null,
                carbody_no: null,
                engine_no: null,
                areashort_id: null,
                code: null,
                is_default: false,
                body_color: null
            },
            items: []   // 选择部分
        }
    },
    methods: {
        add() {
            this.visible = true
        },
        edit(id) {
            console.log(id)
            var that=this
            that.axios.get(CarApi, { params: {id: id}}).then((ret) => {
                if (ret.flag) {
                    that.formData.carcategory_id 
                }
            })
            this.visible = true
        },
        pickModel(item) {
            console.log(item)
            this.formData.carcategory_id = item.id
        },
        pickCarNo(item) {
            console.log(item)
            if (item != null) {
                this.area_name = item.area_name
                this.formData.areashort_id = item.area_id
                this.formData.code = item.code
            } else {
                this.area_name = ''
                this.formData.areashort_id = null,
                this.formData.code = null
            }
        },
        cancel() {
            this.visible = false
        },
        ok() {
            var that = this
            that.axios.post(CarApi, this.formData).then((ret) => {
                if (ret.flag) {
                    refreshCars()
                    that.$emit("refresh",{})
                    this.visible = false
                    Toast('添加完成')
                } else {
                    Toast(ret.info)
                }
            })
        }
    }
}
</script>

<style lang="less">
.btn {
  padding-bottom: 36px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
